import { createFileRoute } from '@tanstack/react-router';
import CandidateMailComposeTemplate from '@/features/agent/candidate_mails/templates/CandidateMailComposeTemplate';

export const Route = createFileRoute('/agent/candidate_mails/new')({
  component: CandidateMailComposeTemplate,
  staticData: { title: 'メール作成' },
});
